import { Maybe } from 'src/models/general.model';
import { FormsScenarioPatch, FormScenarioType } from 'src/models/uiScenarios.model';

export interface UiScenariosState {
  forms?: Maybe<Record<FormScenarioType, Maybe<FormsScenarioPatch>>>;
}

export const INITIAL_ATTRIBUTE_CHANGES_STATE: UiScenariosState = {};
